<div class="create-important-alert-popup">
  <form [formGroup]="alertForm" class="alert-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Titre de l'alerte</mat-label>
      <input
        matInput
        formControlName="title"
        placeholder="Ex: Maintenance planifiée"
        maxlength="255">
      <mat-hint align="end">{{ titleControl?.value?.length || 0 }}/255</mat-hint>
      <mat-error *ngIf="titleControl?.invalid && titleControl?.touched">
        {{ titleErrorText }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Message de l'alerte</mat-label>
      <textarea
        matInput
        formControlName="message"
        placeholder="Saisissez le message de l'alerte..."
        rows="6"
        maxlength="2000">
      </textarea>
      <mat-hint align="end">{{ messageControl?.value?.length || 0 }}/2000</mat-hint>
      <mat-hint align="start">Vous pouvez utiliser du HTML pour le formatage</mat-hint>
      <mat-error *ngIf="messageControl?.invalid && messageControl?.touched">
        {{ messageErrorText }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Audience cible</mat-label>
      <mat-select formControlName="targetAudience">
        <mat-option [value]="TargetAudience.All">
          Tous les utilisateurs
        </mat-option>
        <mat-option [value]="TargetAudience.VetsOnly">
          Vétérinaires uniquement
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="form-info">
      <mat-icon>info</mat-icon>
      <p>Cette alerte sera affichée une seule fois à chaque utilisateur concerné lors de sa prochaine connexion.</p>
    </div>
  </form>
</div>
